import React from "react"
import { RetinaImage } from "./images/RetinaImage"
import { CircleImage } from "./images/CircleImage"

const IlloPartners = () => <RetinaImage name="illo-partners" height={228} width={228} />

const IlloUnderwaterDashboard = () => <RetinaImage name="illo-underwater-dashboard" height={228} width={300} />

const IlloUnderwaterChecklist = () => <RetinaImage name="illo-underwater-checklist" height={228} width={228} />

const IlloWelcome = () => <RetinaImage name="illo-welcome" height={228} width={294} />

const IlloFinancial = () => <RetinaImage name="illo-financial" height={228} width={228} />

const IlloExperts = () => <RetinaImage name="illo-experts" height={228} width={228} />

const IlloGlobal = () => <RetinaImage name="illo-global" height={228} width={228} />

const IlloMoneyBag = () => <RetinaImage name="illo-money-bag" height={140} width={140} />

const IlloChatBubbles = () => <RetinaImage name="illo-chat-bubbles" height={228} width={228} />

const IlloPaperAirplane = () => <RetinaImage name="illo-paper-airplane" height={228} width={228} />

const IlloPaperAirplaneUnderwater = () => <RetinaImage name="illo-paper-airplane-underwater" height={172} width={228} />

const IlloWhereAreYouCompass = () => <RetinaImage name="illo-where-are-you-compass" width={228} height={230} />

const IlloYirTelehealth = () => <RetinaImage name="illo-yir-telehealth" width={228} height={228} />

const IlloWhereAreYouMap = ({ className }) => (
  <RetinaImage className={className} name="illo-where-are-you-map" width={265} height={230} />
)

const IlloUnderwaterDesktop = ({ className }) => (
  <RetinaImage className={className} name="illo-underwater-desktop" width={265} height={230} />
)

const IlloCircleMoneyBag = () => (
  <CircleImage size={160} padding={10} iconName="illo-money-bag" backgroundColor="geyser" />
)

const IlloCircleCarrotCards = () => (
  <CircleImage size={160} padding={32} iconName="illo-carrot-cards" backgroundColor="geyser" />
)

const IlloUnderwaterPlants = ({ height = 130, width = 212 }) => (
  <RetinaImage name="illo-underwater-plants" width={width} height={height} />
)

const IlloCarrotCards = () => <RetinaImage name="illo-carrot-cards" width={192} height={192} />

const IlloLibrary = () => <RetinaImage name="illo-library" height={280.33} width={249} />

const IlloDoctor = ({ className }) => <RetinaImage name="illo-doctor" height={252} width={252} className={className} />

const IlloIvf = ({ className }) => <RetinaImage name="illo-ivf" height={264} width={204} className={className} />

const IlloDocAndCoins = ({ className }) => (
  <RetinaImage name="illo-doc-and-coins" height={228} width={228} className={className} />
)

const IlloPercentCircle = ({ height = 228, width = 228 }) => (
  <RetinaImage name="illo-percent-circle" height={height} width={height} />
)

const IlloBlocks = () => <RetinaImage name="illo-blocks" height={228} width={228} />

const IlloCoinsAndBills = () => <RetinaImage name="illo-coins-and-bills" height={228} width={228} />

const IlloPaperAirplaneCircle = () => (
  <CircleImage size={160} padding={44} iconName="illo-paper-airplane" backgroundColor="geyser" />
)
const IlloCalendar = ({ height = 88, width = 88 }) => <RetinaImage name="illo-calendar" height={height} width={width} />

export {
  IlloPartners,
  IlloUnderwaterDashboard,
  IlloWelcome,
  IlloFinancial,
  IlloExperts,
  IlloGlobal,
  IlloMoneyBag,
  IlloCircleMoneyBag,
  IlloCircleCarrotCards,
  IlloChatBubbles,
  IlloWhereAreYouCompass,
  IlloWhereAreYouMap,
  IlloUnderwaterChecklist,
  IlloUnderwaterPlants,
  IlloCarrotCards,
  IlloLibrary,
  IlloDoctor,
  IlloIvf,
  IlloDocAndCoins,
  IlloPercentCircle,
  IlloBlocks,
  IlloCoinsAndBills,
  IlloPaperAirplane,
  IlloPaperAirplaneCircle,
  IlloPaperAirplaneUnderwater,
  IlloCalendar,
  IlloUnderwaterDesktop,
  IlloYirTelehealth
}
